import { Component, Input } from '@angular/core';
import { GetLIMSDataService } from '../get-limsdata.service';
declare var AesUtil: any;
import '../../assets/AesUtil.js';
import { GlobalDataService } from '../services/global-data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  @Input() banneruser: string;
  @Input() password: string;
  constructor(private getLIMSData: GetLIMSDataService, public globals: GlobalDataService) { }

  doLogin(user, password) {
    if (!user || user === 'guest') {
      alert('Please provide user name.');
      return;
    }
    if (!password) {
      alert('Please provide a password.');
      return;
    }
    user = encodeURIComponent(user).toUpperCase();
    const encryptedPassword = this.encryptPassword(password);
    (this.getLIMSData.checkLogin(user, encryptedPassword));
  }

  encryptPassword(inword) {
      const iv = 'F27D5C9927726BCEFE7510B1BDD3D137';
      const salt = '3FF2EC019C627B945225DEBAD71A01B6985FE84C95A70EB132882F88C0A59A55';
      const keySize = 128;
      const iterationCount = 10000;
      const passPhrase = 'IODP';

      const aesUtil = new AesUtil(keySize, iterationCount);
      const xxx = aesUtil.encrypt(salt, iv, passPhrase, inword);
      return xxx;
  }

  doCancel() {
    this.banneruser = 'Guest';
    this.password = '';
    this.globals.username = 'guest';
    this.globals.encryptedPassword = '';
    this.globals.showLoginPanel = false;
  }
}
